import React, { useEffect, useRef } from 'react';

const Popup = ({ onClose }) => {
    const popupRef = useRef(null);

    useEffect(() => {
        // Function to close the popup when clicking outside of it
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                onClose();
            }
        };

        // Add event listener for clicks
        document.addEventListener('mousedown', handleClickOutside);

        // Cleanup event listener on component unmount
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);

    return (
        <div className="fixed inset-0 z-50 bg-black/80 text-white">
            <div
                ref={popupRef} // Attach the ref to the modal container
                className=" left-[50%] top-[50%] z-50 grid max-w-lg translate-x-[-50%] translate-y-[-50%] gap-2 p-6 shadow-lg duration-200 sm:rounded-lg w-10/12 rounded-lg bg-black/50 backdrop-blur-md sm:max-w-[425px] relative"
            >
                {/* Close button (cross) */}
                <button
                    onClick={onClose}
                    className="absolute top-3 right-3 text-white text-2xl font-semibold"
                >
                    &times;
                </button>
                <h2 className="text-xl">Register Email</h2>
                <p className="text-xs mb-4 text-[#a3a3a3]">Enter your email address to receive updates and notifications.</p>
                <div className='flex flex-col gap-2'>
                    <label className='text-xs' htmlFor="email">Email</label>
                    <input
                        type="email"
                        placeholder="Enter Your Email"
                        className="w-full p-2 mb-4 text-sm border border-gray-800 rounded bg-transparent"
                    />
                </div>
                <div className='flex justify-end text-sm'>
                    <button className="bg-white text-black font-light px-4 py-2 rounded" onClick={onClose}>
                        Register
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Popup;
